<template>
    <label
        v-if="value || !!$slots.default"
        :for="id"
        :class="[
            isBig
                ? 'text-xl font-header font-semibold mb-4 flex items-center'
                : 'text-sm',
            'flex gap-x-2',
            { 'text-input-label': !disabled },
            { 'text-input-muted': disabled },
        ]"
    >
        <!-- If the checkox has a label, the checkbox needs to be inside the label -->
        <slot name="checkbox-slot" />
        <span v-if="value" v-text="value" />
        <slot v-else-if="!!$slots.default" />
        <TextTooltip v-if="description" :text="description">
            <PhQuestion
                class="size-5 text-primary hover:text-primary-hover transition-colors duration-button-hover cursor-help"
                weight="fill"
            />
        </TextTooltip>
        <span v-if="required" class="text-input-muted">
            ({{ $lang.get('required') }})
            <span class="text-red-500">*</span>
        </span>
    </label>
</template>

<script>
import TextTooltip from '@/Components/Elements/TextTooltip.vue'
import { PhQuestion } from '@phosphor-icons/vue'
export default {
    components: {
        TextTooltip,
        PhQuestion,
    },

    props: {
        id: {
            type: [String, Number],
            required: false,
        },
        value: {
            type: [String, null],
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        description: {
            type: String,
        },
        isBig: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
